// eslint-disable-next-line
export const getTableColumns = (t) => {
  return [
    {
      title: t('paymentScheduleTable.paymentDate'),
      property: 'paymentDate',
      sortable: false,
    },
    {
      title: t('paymentScheduleTable.paymentAmount'),
      property: 'amount',
      sortable: false,
    },
    {
      title: t('paymentScheduleTable.date'),
      property: 'createdAt',
      sortable: false,
    },
    {
      title: t('paymentScheduleTable.state'),
      sortable: false,
      customCell: (row) => (
        row.paid ? t('paymentScheduleTable.paid') : t('paymentScheduleTable.failed')
      ),
    },
  ];
};
